"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormControlledSelect = void 0;
var react_1 = __importDefault(require("react"));
var acid_components_1 = require("@michelin/acid-components");
var react_hook_form_1 = require("react-hook-form");
function FormControlledSelect(props) {
    var name = props.name, rules = props.rules, control = props.control, label = props.label, options = props.options, readOnly = props.readOnly, error = props.error, helperText = props.helperText;
    return (react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: name, rules: rules, render: function (_a) {
            var field = _a.field;
            return (react_1.default.createElement(acid_components_1.Select, __assign({ id: name, label: label, options: options, error: error, helperText: helperText, readOnly: readOnly, required: !!(rules === null || rules === void 0 ? void 0 : rules.required), fullWidth: true }, field)));
        } }));
}
exports.FormControlledSelect = FormControlledSelect;
//# sourceMappingURL=FormControlledSelect.js.map